export default "__VITE_ASSET__CpwUU65n__"